"use client";
import { jsx as n } from "react/jsx-runtime";
import { SelectContent as o } from "../../atoms/Select/Select.mjs";
import { cn as a } from "../../../utils/utils.mjs";
const l = ({ className: r, children: t, ...e }) => /* @__PURE__ */ n(
  o,
  {
    className: a(
      "min-w-38 rounded-xl px-0  dark:bg-neutral-dark-200 border dark:border-neutral-dark-300",
      r
    ),
    ...e,
    children: t
  }
);
export {
  l as SelectInputContent
};
